<script lang="ts">
import { defineComponent } from "vue";
import { ref } from "vue";
import IconSprite from "@/components/IconSprite.vue";

export default defineComponent({
  name: "Modal",
  components: { IconSprite },
  emits: ["closeModal", "closeModalJa"],
  props: {
    titel: String,
    text: String,
    hatSchliessenButton: {
      type: Boolean,
      default: false,
    },
    schliessenButtonText: {
      type: String,
      default: "",
    },
    hatJaNeinButton: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const modalTitel = ref(props.titel == undefined ? "" : props.titel);
    const modalText = ref(props.text == undefined ? "" : props.text);
    const verborgen = ref(false);

    function closeModal() {
      emit("closeModal");
    }

    function closeModalJa() {
      emit("closeModalJa");
    }

    function textVerbergenToggle() {
      verborgen.value = !verborgen.value;
    }

    return {
      props,
      modalTitel,
      modalText,
      closeModal,
      closeModalJa,
      textVerbergenToggle,
      verborgen,
    };
  },
});
</script>

<template>
  <div class="c-modal" id="modal-angebot-per-mail">
    <section class="c-modal__content">
      <header class="c-modal__header">
        <h1 class="c-modal__title">
          <slot name="titel">{{ modalTitel }}</slot>
        </h1>
        <button type="button" class="c-button c-button--icon-only-white" @click="closeModal()">
          <icon-sprite icon-name="icon-cross" />
          <span class="c-button__visually-hidden">close</span>
        </button>
      </header>
      <section class="c-modal__content-section u-text-align-left">
        <div v-if="modalText !== '' && !verborgen" class="u-mar-b-1">
          <slot name="text">
            {{ modalText }}
          </slot>
        </div>

        <!-- Die Inklusion von weiteren Inhalten, z.B. Komponenten durch einen Slot ermöglichen -->
        <slot name="inhalt" :closeModal="closeModal" :textVerbergenToggle="textVerbergenToggle"></slot>

        <div v-if="props.hatJaNeinButton === true" class="o-grid">
          <div class="o-grid__cell o-grid__cell--2 o-grid__cell--offset-8 form-actions u-mar-b-0 u-text-align-right">
            <button class="c-button" type="button" data-cy="closeModalYes" @click="closeModalJa()">Ja</button>
          </div>
          <div class="o-grid__cell o-grid__cell--2 form-actions u-mar-b-0 u-text-align-right">
            <button class="c-button" type="button" data-cy="closeModalNo" @click="closeModal()">Nein</button>
          </div>
        </div>

        <div v-if="props.hatSchliessenButton === true" class="o-grid">
          <div class="o-grid__cell o-grid__cell--12 form-actions u-mar-b-0 u-text-align-right">
            <button class="c-button" type="button" data-cy="closeModal" @click="closeModal()">
              {{ props.schliessenButtonText ? props.schliessenButtonText : "OK" }}
            </button>
          </div>
        </div>
      </section>
    </section>
  </div>
</template>

<style scoped></style>
